import { Activity, Globe, MonitorSmartphone, Volume2, VolumeX, Wallet, HelpCircle } from 'lucide-react';
import { usePresence } from '../lib/presence';
import { useAuth } from '../lib/auth';
import { useRoom } from '../lib/room';
import { useSettings } from '../store/settings';
import { market, isMp, useTick } from '../lib/runtime';
import { openModal } from '../store/ui';
import { SIM, PROJECT } from '../../shared/config';
import { sol } from '../lib/format';
import { SolIcon } from './common';

const I = { size: 14, strokeWidth: 1.75 };
/** Bottom status bar (32px, UI spec §1). */
export function StatusBar() {
  const p = usePresence(); const sync = useAuth((s) => s.sync); const user = useAuth((s) => s.user);
  const room = useRoom(); const s = useSettings(); useTick((t) => t.fast);
  const m = market();
  return <footer className="statusbar">
    <span className="sb-chip" title="Active quick-buy preset"><SolIcon size={11} />{s.quickBuySol}</span>
    <span className="sb-item"><Wallet {...I} /><SolIcon size={11} />{sol(m.balance, true, 2)}</span>
    <button className={`sb-toggle ${s.feedOpen ? 'on' : ''}`} onClick={() => s.set({ feedOpen: !s.feedOpen })}>Social</button>
    <a className="sb-toggle" href="#/discover">Discover</a>
    <a className="sb-toggle" href="#/pulse">Pulse</a>
    <a className="sb-toggle" href="#/portfolio">PnL</a>
    <span className="sb-item" title="Open tabs connected to this server's presence socket"><i className={`dot ${p.state === 'open' ? 'ok' : 'bad'}`} />{p.online == null ? 'offline' : `${p.online} online`}</span>
    {room.code && <span className="sb-item">room {room.code} · {room.status}{room.rtt != null ? ` · ${room.rtt}ms` : ''}</span>}
    <span className="sb-item" title="Cloud progress sync">{user ? `sync: ${sync}` : 'local only'}</span>
    <div className="grow" />
    <span className="sb-item"><SolIcon size={11} />${SIM.SOL_USD.toFixed(2)}</span>
    <span className="sb-item"><Activity {...I} />{isMp() ? 'room-ordered' : `${s.latencyMs}ms`}</span>
    <span className="sb-item"><Globe {...I} />SIM-1</span>
    <span className="sb-item sim"><MonitorSmartphone {...I} />Simulation only · no real trades, no real funds</span>
    <a className="sb-item" href={PROJECT.x} target="_blank" rel="noopener noreferrer" title="PAPERXIOM on X">𝕏</a>
    <button className="sb-icon" onClick={() => s.set({ sound: !s.sound })} title="Mute (M)">{s.sound ? <Volume2 {...I} /> : <VolumeX {...I} />}</button>
    <button className="sb-icon" onClick={() => openModal('help')} title="Shortcuts (?)"><HelpCircle {...I} /></button>
  </footer>;
}
